import states from "./States";

export const DefaultSearchFieldsHorseTrailer = {
    categoryName: "Horse Trailers",
    fields : [
        {
            hideField: false,
            label: "Newest listings",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "1",
            sortable: true, // Some fields are only for sorting
            isBeingSorted: false, // If a sort isn't supplied, default to this one.
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Year",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "6",
            sortable: true,
            isBeingSorted: true, // If a sort isn't supplied, default to this one.
            isDefaultSort: true,
            sortDirection: "desc"
        },
        {
            hideField: false,
            label: "Distance from your zipcode",
            fieldType: "sortonly",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "166",
            sortable: true,
            sortDirection: "asc",
        },
        {
            hideField: false,
            label: "Manufacturer",
            fieldType: "multiselect",
            searchValues: [], // Some fields, like manufacturer and horses, will be populated when the app initializes
            selectedValue: "", // Used by textboxes, checkboxes, select
            selectedValues: [], // Used by multiselect
            filterId: "7",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Pull",
            fieldType: "select",
            searchValues:
                [
                    // select options should have an "Any" field, but omit this option from multiselect
                    {
                        label: "Any",
                        value: ""
                    },
                    {
                        label: "Gooseneck",
                        value: "G"
                    },
                    {
                        label: "Bumper pull",
                        value: "B"
                    },
                    {
                        label: "Horse Vans",
                        value: "V"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "10",
        },
        {
            hideField: false,
            label: "Horses",
            fieldType: "multiselect",
            searchValues: [
                {
                    label: "1",
                    value: "1"
                },
                {
                    label: "2",
                    value: "2"
                },
                {
                    label: "2 + 1",
                    value: "2 + 1"
                },
                {
                    label: "3",
                    value: "3"
                },
                {
                    label: "4",
                    value: "4"
                },
                {
                    label: "5",
                    value: "5"
                },
                {
                    label: "6",
                    value: "6"
                },
                {
                    label: "7",
                    value: "7"
                },
                {
                    label: "8",
                    value: "8"
                },
                {
                    label: "9",
                    value: "9"
                },
                {
                    label: "10",
                    value: "10"
                },
                {
                    label: "11",
                    value: "11"
                },
                {
                    label: "12",
                    value: "12"
                },
                {
                    label: "13",
                    value: "13"
                },
                {
                    label: "14",
                    value: "14"
                },
                {
                    label: "15",
                    value: "15"
                },
                {
                    label: "Stock",
                    value: "Stock"
                },
                {
                    label: "Miniature",
                    value: "Miniature"
                },
                {
                    label: "Pigs/Sheep",
                    value: "Pigs/Sheep"
                },
                {
                    label: "Draft Horse",
                    value: "Draft Horse"
                }
            ],
            selectedValue: "",
            selectedValues: [],
            filterId: "9",
        },
        {
            hideField: false,
            label: "Living Quarters",
            fieldType: "select",
            searchValues:
                [
                    // select options should have an "Any" field, but omit this option from multiselect
                    {
                        label: "Any",
                        value: ""
                    },
                    {
                        label: "Yes",
                        value: "Yes"
                    },
                    {
                        label: "No",
                        value: "No"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "11",
        },
        {
            hideField: false,
            label: "New or Used",
            fieldType: "select",
            searchValues:
                [
                    // select options should have an "Any" field, but omit this option from multiselect
                    {
                        label: "Any",
                        value: ""
                    },
                    {
                        label: "New",
                        value: "Y"
                    },
                    {
                        label: "Used",
                        value: "N"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "39",
        },
        {
            hideField: false,
            label: "Price",
            fieldType: "multiselect",
            searchValues:
                [
                    {
                        label: "Under $2,500",
                        value: "0-2500"
                    },
                    {
                        label: "$2,500 to $5,000",
                        value: "2500-5000"
                    },
                    {
                        label: "$5,000 to $10,000",
                        value: "5000-10000"
                    },
                    {
                        label: "$10,000 to $20,000",
                        value: "10000-20000"
                    },
                    {
                        label: "$20,000 +",
                        value: "20000-999999"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "23",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Living Quarters Length",
            fieldType: "select",
            searchValues:
                [
                    // select options should have an "Any" field, but omit this option from multiselect
                    {
                        label: "Any",
                        value: ""
                    },
                    {
                        label: "10' or less",
                        value: "1-120"
                    },
                    {
                        label: "Greater than 10'",
                        value: "121-999"
                    }
                ],
            selectedValue: "",
            selectedValues: [],
            filterId: "161",
            sortable: true,
            sortDirection: "asc"
        },
        {
            hideField: false,
            label: "Your zipcode",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "zip", // The zip code distance is a unique field. It has a searchkey of 'zip', but a sort field of 166
            setFilterIdWhenChanged: "166" // When this field is entered, default the sort field. A user can still change it.
        },
        {
            hideField: false,
            label: "Stock #",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "30",
        },
        {
            hideField: false,
            label: "City",
            fieldType: "textbox",
            searchValue: "",
            selectedValue: "",
            selectedValues: [],
            filterId: "14",
        },
        {
            hideField: false,
            label: "State",
            fieldType: "multiselect",
            searchValues: states,
            selectedValue: "",
            selectedValues: [],
            filterId: "15",
        },
        {
            hideField: false,
            label: "Custom #1",
            fieldType: "checkbox",
            searchValue: "Y",
            selectedValue: "",
            selectedValues: [],
            filterId: "45",
        },
        {
            hideField: false,
            label: "Extra #1",
            fieldType: "checkbox",
            searchValue: "1",
            selectedValue: "",
            selectedValues: [],
            filterId: "49",
        },

    ]
}
